export default __webpack_public_path__ + "static/media/binance-usd-busd-logo.488237bc.svg";